import ApiService from "@/core/services/api.service";

const state = {
  toSave: 0,
  isBusy: false,
  id: null,
  group: {
    id: null,
    name: null,
    description: null,
  },
};

const actions = {
  /**
   * Specify.
   *
   * @param context
   * @param group
   */
  specifyEmpGroupEdit(context, group) {
    context.commit("setEmpGroupEdit", group);
  },

  /**
   * Update.
   *
   * @param context
   * @param form
   * @returns {*}
   */
  updateEmployeeGroupForm(context, form) {
    context.commit("holdEmpGroupEditBusy");
    ApiService.setHeader();
    return ApiService.post("group/record/update", form)
      .then(() => {
        console.log("Updated ", form);

        const group = {
          id: form.id,
          name: form.name,
          description: form.description,
        };

        context.commit("setEmpGroupEdit", group);
        context.dispatch("getEmployeeGroup").then(console.log);
      })
      .finally(() => context.commit("holdEmpGroupEditBusy"));
  },

  /**
   * Tell the form to submit.
   *
   * @param context
   */
  engageUpdateEmployeeGroupForm(context) {
    let count = state.toSave;
    console.log(count);
    context.commit("setUpdateEmpGroupFormSubmission", ++count);
  },
};

const mutations = {
  setEmpGroupEdit(state, group) {
    state.group = group;
  },
  setUpdateEmpGroupFormSubmission(context, saveState) {
    state.toSave = saveState;
  },
  holdEmpGroupEditBusy(state) {
    state.isBusy = !state.isBusy;
  },
};

const getters = {
  getGroupInformation: (state) => state.group,
  getHeldEmpEditGroup: (state) => state.isBusy,
  checkUpdateEmpGroupScheduleEvent: (state) => state.toSave,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
